const moneyFormat = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

export const formatMoney = (value: number): string => moneyFormat.format(value);

const dateFormat = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export const formatDate = (isoDate: string): string => dateFormat.format(new Date(isoDate));

/**
 * Дата для <input type="date">. Собираем из локальных частей: toISOString
 * переводит в UTC и вечером выдаёт вчерашнее число.
 */
export function isoDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${date.getFullYear()}-${month}-${day}`;
}

export const todayIso = (): string => isoDate(new Date());

const dateTimeFormat = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export const formatDateTime = (iso: string): string => dateTimeFormat.format(new Date(iso));

const monthNameFormat = new Intl.DateTimeFormat('ru-RU', { month: 'long' });

/**
 * «август 2026» — подпись месяца в списке выбора. Отчёт приходит со своей
 * подписью с сервера; здесь нужны только варианты, которых ещё не выбирали.
 */
export const formatMonth = (year: number, month: number): string =>
  `${monthNameFormat.format(new Date(year, month - 1, 1))} ${year}`;

/**
 * «5 лет», «21 год», «22 года». Возраст показывается родителю и в списках,
 * а «5 лет» против «5 год» — первое, что бросается в глаза.
 */
export function formatAge(years: number): string {
  const lastTwo = years % 100;
  const last = years % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return `${years} лет`;
  }
  if (last === 1) {
    return `${years} год`;
  }
  if (last >= 2 && last <= 4) {
    return `${years} года`;
  }
  return `${years} лет`;
}
